import { Button, Flex, Input } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useShowNotification } from 'hooks';

type Props = {
  value: string;
};

export const InputWithCopyButton = ({ value }: Props) => {
  const { t } = useTranslation('common');
  const showNotification = useShowNotification();
  const copyToClipboard = () => {
    navigator.clipboard.writeText(value);
    showNotification({
      message: t('inputWithCopyButton.toast'),
      variant: 'success',
    });
  };

  return (
    <Flex gap="xs">
      <Input sx={{ flex: 1 }} value={value} readOnly />
      <Button onClick={copyToClipboard}>
        {t('inputWithCopyButton.button')}
      </Button>
    </Flex>
  );
};
